module.exports ={
    shops: {
        all: '所有门店',
        statusOpt:[
            {
                label: '所有门店',
                value: true
            },{
                label: '已关闭门店',
                value: false
            }
        ],
        add:'添加',
        addTip: {
            success: '门店添加成功',
            exist: '门店已存在',
            fail:'门店添加失败',
            permission: '您没有权限添加门店'
        },
        find:'查找门店',
        addTitle: '添加门店',
        storeId: '门店编号',
        no:'编号: ',
        storeIdMsg: '请输入门店编号',
        storeIdMsg1: '请输入数字或字母',
        storeIdExist: '门店已存在',
        storeIdFail: '获取失败,请重新输入',
        storeName: '门店名称',
        storeNameMsg: '请输入门店名称',
        storeAddress: '门店地址',
        address: '地址: ',
        storeAddressMsg: '请输入门店地址',
        serviceAddress: '服务器地址',
        serviceAddressMsg: '请输入合法的服务器地址',
        storeImg: '门店封面',
        storeImgMsg: '请上传门店封面',
        cancel: '取 消',
        save: '保 存',
        uploadMsg: '上传新封面',
        uploadType:'上传图片只能是JPG或PNG格式!',
        uploadSizeLt: '图片尺寸必须在370*370以内!',
        uploadFailed:'上传图片失败',
        sure: '确 定',
        status: {
            on: '已开启',
            off: '已关闭'
        },
        noData: '暂无数据',
        submiting: '保存中...'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/shops.js